import React from "react"

interface ColumnProperties {
    children: (React.JSX.Element | string | null)[] | React.JSX.Element | string
    className?: string
    maxWidth?: number
}

export default function Column({
    children,
    className,
    maxWidth
}: ColumnProperties){
    const createStyle = () => {
        const style: React.CSSProperties = {
            display: 'flex',
            flexDirection: 'column'
        }

        if(maxWidth){
            style.maxWidth = maxWidth
        }

        return style
    }

    return <div className={className} style={createStyle()}>
        {children}
    </div>
}